export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '18335937-272b-4696-80ad-5c8b25103f88';
export const MODAL_CLOSE_SEC = 2.5;
